import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { TSubmitDebtScheduleVars } from './debt-schedule.types';
import { submitDebtSchedule } from './debt-schedules.service';

import { useMutationWithPartnerRefetch } from '@/shared';

export const usePostDebtSchedule = (): ReturnType<
	typeof useMutation<void, AxiosError, TSubmitDebtScheduleVars>
> => {
	return useMutationWithPartnerRefetch({
		mutationFn: submitDebtSchedule,
	});
};
